module.exports = __webpack_public_path__ + "media/application/images/ui/menu-tile-active-e357eb5420cbcb532e9356d4097f1acc.svg";